import { useSyncExternalStore } from 'react';

import type { ResolvedTheme, ThemePreference } from './theme';
import {
  getResolvedTheme,
  getThemePreference,
  setThemePreference,
  subscribeTheme,
} from './theme-store';

export interface UseThemeResult {
  /** 使用者選的三態偏好。 */
  readonly preference: ThemePreference;
  /** `system` 解析後實際套用的主題（UI 顯示「目前是深色/淺色」用）。 */
  readonly resolved: ResolvedTheme;
  readonly setPreference: (preference: ThemePreference) => void;
}

export function useTheme(): UseThemeResult {
  const preference = useSyncExternalStore(subscribeTheme, getThemePreference, getThemePreference);
  const resolved = useSyncExternalStore(subscribeTheme, getResolvedTheme, getResolvedTheme);
  return { preference, resolved, setPreference: setThemePreference };
}
